// SCSS
import '../scss/bootstrap.scss';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import '../scss/main.scss';

//jQuery
import "jquery"; //Do not delete!!! Doesn't import jQuery, but used as placeholder.
import 'bootstrap';
import 'ekko-lightbox';
import OverlayScrollbars from 'overlayscrollbars';

import './interval';
import './slider';
import FacilityModal from './facility-modal';
import Modal from './modal';
import StickyHeader from './sticky-header';
import Cookie from './cookie';

// CSS Breakpoints
const swBreakpoint = {
    'xxs': 0,
    'xs': 375,
    'sm': 576,
    'md': 768,
    'lg': 1024,
    'xl': 1200,
    'xxl': 1600,
};

// Check if touch device
let isTouch = false;
if ("ontouchstart" in window || "ontouch" in window) {
    isTouch = true;
    document.body.classList.add('touch');
}
const pageLoader = document.getElementById('pageLoader');
window.addEventListener('load', (event) => {
    document.body.classList.add('loaded');
    if (pageLoader) {
        setTimeout(() => pageLoader.remove(), 400);
    }
});

// Check if is Home Page
const isHome = document.body.classList.contains('home');

// Mobile Menu
const mainMenu = new Modal('.main-sidebar', '.menu-toggle', ['open-menu']);

const cookies = new Cookie('.cookie-banner-wrapper');

// History Modal
if (document.querySelector('.history-modal')) {
    const historyModal = new Modal('.history-modal', '.history-toggle', ['open-history', 'overflow-hidden']);
}

// Submenu Tigger
const topLevelItems = document.querySelectorAll('.header-nav .menu-item-has-children');
topLevelItems.forEach((item) => {
    const submenu = item.querySelector('.sub-menu');
    const trigger = document.createElement('button');
    trigger.innerHTML = '+'
    trigger.classList.add('sub-menu-trigger');
    if (item.classList.contains('current_page_item') || item.classList.contains('current_page_parent')) {
        toggleSubMenu(item, trigger)
    }
    trigger.setAttribute('aria-label', 'Show Sub Menu')
    item.insertBefore(trigger, submenu);
    // if (isTouch) {
    trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleSubMenu(item, trigger);
    })
    // }else{
    // 	trigger.addEventListener('mouseover', (e) => {
    // 		item.classList.add('open');
    // 		trigger.innerHTML = '-'
    // 	})
    // 	trigger.addEventListener('mouseleave', (e) => {
    // 		item.classList.remove('open');
    // 		trigger.innerHTML = '+'
    // 	})
    // }
})

function toggleSubMenu(item, trigger) {
    const submenu = item.querySelector('.sub-menu')

    if (item.classList.contains('open')) {
        submenu.style = ''
        item.classList.remove('open');
        trigger.innerHTML = '+'
        return;
    }

    const openMenu = document.querySelector('.header-nav .menu-item-has-children.open')
    if (openMenu) {
        submenu.style = ''
        openMenu.classList.remove('open');
        trigger.innerHTML = '+'
    }

    const submenuItems = submenu.querySelectorAll('.menu-item')
    let submenuHeight = 0
    submenuItems.forEach(menuItem => {
        submenuHeight += menuItem.clientHeight;
    });
    submenu.style.height = submenuHeight + 'px';
    item.classList.add('open');
    trigger.innerHTML = '-'
}

// Sticky Header
if (!document.body.classList.contains('no-sticky-header')) {
    new StickyHeader({
        observedSection: isHome ? '.hero-home' : '.top-featured-image',
        rootMargin: window.innerWidth <= swBreakpoint.lg ? '-75px' : '-130px',
        triggerCallback: function() {
            return window.innerWidth <= swBreakpoint.lg || isHome
        }
    });
}


// Custom Scrollbar
document.addEventListener("DOMContentLoaded", function() {
    OverlayScrollbars(document.querySelectorAll(".scrollbox-light"), {
        className: 'os-theme-light'
    });

    OverlayScrollbars(document.querySelectorAll(".scrollbox-dark"), {
        className: 'os-theme-dark'
    });
});

//AnimateOnFirstEntry 
const animateOnFirstEntryElements = document.querySelectorAll('.animate-me');
const animateOnFirstEntryObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animated')
        }
    });
}, {
    root: null,
    rootMargin: '-130px',
    threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
});

animateOnFirstEntryElements.forEach(element => {
    animateOnFirstEntryObserver.observe(element);
});


// Highligh Fish
const fishes = document.querySelectorAll('.fish-showcase-item .fish-img-wrapper img');
const highlightObserver = new IntersectionObserver(higlightFish, {
    root: null,
    rootMargin: '-130px',
    threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
});
fishes.forEach(fish => {
    fish.intersectionRatio = 0
    highlightObserver.observe(fish);
});

function higlightFish(entries, observer) {
    //Converion from NodeList to Array
    const fishesArray = Array.prototype.slice.call(fishes);

    //Pass intersectionRatio on NodeElement of each entry 
    entries.forEach(entry => {
        entry.target.intersectionRatio = entry.intersectionRatio
    });

    //Find max intersetionRatio
    const max = fishesArray.reduce((max, fish) => fish.intersectionRatio > max ? fish.intersectionRatio : max, 0);

    //Highlight value with max intersetionRatio and unhighlight the rest
    fishesArray.forEach(fish => {
        if (fish.intersectionRatio === max) {
            fish.closest('.fish-showcase-item').classList.add('intersecting')
        } else {
            fish.closest('.fish-showcase-item').classList.remove('intersecting')
        }
    });
};
const backToTop = document.querySelector('.back-to-top');
if (backToTop) {
    window.addEventListener('scroll', function(e) {
        if (window.scrollY >= window.innerHeight) {
            backToTop.classList.add('visible');
        } else {
            backToTop.classList.remove('visible');
        }
    })
}


// Floating Fish
const floatingFish = document.querySelector('.floating.speaking-fish')
if (floatingFish) {
    floatingFish.querySelector('.fish').addEventListener('click', (e) => {
        if (floatingFish.classList.contains('open')) {
            floatingFish.classList.remove('open')
            floatingFish.classList.add('closing');
            setTimeout(() => {
                floatingFish.classList.remove('closing');
            }, 600)
        } else {
            floatingFish.classList.add('open');
            setTimeout(() => {
                if (document.querySelector('.notice')) {
                    document.querySelector('.notice').remove()
                }
                document.body.addEventListener('click', (e) => {
                    floatingFish.classList.remove('open')
                    floatingFish.classList.add('closing');
                    setTimeout(() => {
                        floatingFish.classList.remove('closing');
                    }, 600)
                }, {
                    once: true
                });
            }, 400);
        }
    })


    const flotingFishobserver = new IntersectionObserver(
        function(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    floatingFish.style.display = 'none'
                } else {
                    floatingFish.style.display = 'flex'
                }
            });
        }, {
            root: null,
            rootMargin: window.innerWidth <= swBreakpoint.lg ? '-15px' : '-90px',
            threshold: [0.0, 1.0]
        });
    flotingFishobserver.observe(document.querySelector('#footer'));
}

// Floating History
const floatingHistory = document.querySelector('.history-bubble.floating-bubble')
if (floatingHistory) {
    const flotingHistoryobserver = new IntersectionObserver(
        function(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    floatingHistory.style.display = 'none'
                } else {
                    floatingHistory.style.display = 'block'
                }
            });
        }, {
            root: null,
            rootMargin: window.innerWidth <= swBreakpoint.lg ? '-15px' : '-90px',
            threshold: [0.0, 1.0]
        });
    flotingHistoryobserver.observe(document.querySelector('#footer'));
}

//Facilities Map
if (typeof facilitiesData !== 'undefined') {
    for (let [key, value] of Object.entries(facilitiesData)) {
        new FacilityModal('.' + key, value)
    }
}

//Contact Form Map
if (typeof google !== 'undefined' && document.getElementById('map')) {
    google.maps.event.addDomListener(window, 'load', function() {

        // Get the HTML DOM element that will contain your map 
        var mapElement = document.getElementById('map');

        // Create the Google Map using our element and options defined above
        var map = new google.maps.Map(mapElement, {
            zoom: 16,
            center: new google.maps.LatLng(38.3548797, 22.3788353),
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            styles: [{
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#444444"
                    }]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "labels.text",
                    "stylers": [{
                            "saturation": "18"
                        },
                        {
                            "lightness": "-55"
                        },
                        {
                            "visibility": "simplified"
                        },
                        {
                            "color": "#4484a1"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [{
                            "color": "#f2f2f2"
                        },
                        {
                            "saturation": "28"
                        },
                        {
                            "lightness": "42"
                        },
                        {
                            "gamma": "2.01"
                        },
                        {
                            "weight": "1"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [{
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "simplified"
                    }]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{
                        "visibility": "off"
                    }]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [{
                            "color": "#aaced9"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        });

        var center;
        // Add markers on the map
        if (places.length) {
            const markers = places.map(function(place, i) {
                const marker = new google.maps.Marker({
                    position: place.location,
                    icon: "/wp-content/themes/gsm_theme/assets/img/pin.png",
                    title: place.title,
                    zoom: 17,
                    map: map,
                    animation: google.maps.Animation.DROP,
                    infowindow: new google.maps.InfoWindow({
                        content: '<h3 class="h6">' + place.title + '</h3><p>' + place.description + '</p><a href="' + place.direction_link + '">' + place.direction_text + '</a>',
                    })
                });

                if (place.center) {
                    center = place.location;
                }

                // Bind Info Window to marker click
                google.maps.event.addListener(marker, 'click', (function(marker) {
                    return () => {
                        markers.map((_marker) => _marker.infowindow.close())
                        marker.infowindow.open(map, marker);
                    };
                })(marker, place));

                return marker;
            });
            map.setCenter(markers[0].position)
        }
    });
}

$(document).ready(function() {
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        const close = document.createElement('button');
        close.innerHTML = '<span class="sr-only">Close</span>';
        close.classList.add('modal-close')
        event.preventDefault();
        $(this).ekkoLightbox({
            maxWidth: 1080,
            leftArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.41 34.81"><path fill="#ffffff" d="M17.41 34.81L0 17.41 17.41 0"/></svg>',
            rightArrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.41 34.81"><path fill="#ffffff" d="M0 34.81l17.41-17.4L0 0"/></svg>',
            alwaysShowClose: false,
            onShow: () => {
				document.body.append(close);
				close.addEventListener('click', ()=>{
					$('.ekko-lightbox').modal('hide')
				})
            },
            onHide: () => {
                close.remove()
            }
        });
    });

    if ($('[data-toggle="tooltip"]').length) {
        $('[data-toggle="tooltip"]').tooltip({
            template: '<div class="tooltip" role="tooltip"><div class="tooltip-inner"></div></div>'
        })

        $('[data-toggle="tooltip"]').on('shown.bs.tooltip', function(e) {
            setTimeout(() => {
                $('[data-toggle="tooltip"]').tooltip('hide')
            }, 3000)
        })
    }

    if ($('.share-popover-trigger').length) {
        $('.share-popover-trigger').popover({
            content: '<div class="social email"><a target="_blank" href="' + encodeURI('mailto:?Body=' + window.location + ' ' + document.title) + '">Email</a></div><div class="social twitter"><a target="_blank" href="' + encodeURI('https://twitter.com/intent/tweet?text=' + document.title + '&url=' + window.location) + '">Twitter</a></div><div class="social facebook"><a href="' + encodeURI('http://www.facebook.com/sharer.php?u=' + window.location) + '">Facebook</a></div><div class="social link"><a href="#" class="share-popover-link">Link</a></div>',
            html: true,
            template: '<div class="popover share-popover" role="tooltip"><div class="popover-body"></div></div>',
            placement: 'top'
        })

        $('.share-popover-trigger').on('shown.bs.popover', function(e) {
            $('.share-popover-link').on('click', function(event) {
                event.preventDefault();
                copyTextToClipboard(window.location);
                $('.share-popover').popover('hide');
            });
            $('.share-popover a:not(.share-popover-link)').on('click', function() {
                $('.share-popover').popover('hide');
            })
            $('body').one('click', function(e) {
                if ($(e.target).closest('.share-popover').length === 0) {
                    $('.share-popover').popover('hide');
                }
            })
        })


    }

    if ($('.time-popover-trigger').length) {
        $('.time-popover-trigger').popover({
            html: true,
            template: '<div class="popover time-popover" role="tooltip"><div class="popover-close"></div><img class="popover-icon" src="' + '/wp-content/themes/gsm_theme/assets/img/time.svg' + '"><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
            placement: 'top'
        })
        $('.time-popover-trigger').on('shown.bs.popover', function(e) {

            $('.popover-close').on('click', function() {
                $('.time-popover').popover('hide');
            })

            $('body').one('click', function(e) {
                if ($(e.target).closest('.time-popover').length === 0) {
                    $('.time-popover').popover('hide');
                }
            })
        })
    }

    if ($('.toggle-news-nav').length) {
        $('.toggle-news-nav').popover({
            content: document.querySelector('.news-nav').innerHTML,
            html: true,
            template: '<div class="popover news-popover" role="tooltip"><div class="popover-body"></div></div>',
            placement: 'bottom'
        })

        $('.toggle-news-nav').on('shown.bs.popover', function(e) {
            $('.news-popover a').on('click', function() {
                $('.news-popover').popover('hide');
            })
        })
        $('body').one('click', function(e) {
            if ($(e.target).closest('.news-popover').length === 0) {
                $('.news-popover').popover('hide');
            }
        })
	}
	
	// Writing Analytics Scripts in Header
	if (cookies.acceptedCookie){
		console.log('Cookie has been Accepted . Writing Analytics Scripts');
		var headerScripts = sw_php_vars.analyticsScript;
	}
	
});

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        if (!successful) {
            console.log('Fallback: Copying text command was unsuccessful');
        }
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function() {
        // console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}